<script lang="ts">
  import Router from 'svelte-spa-router';
  import EditorLayout from '../components/editor/EditorLayout.svelte';
  import EditorHome from '../components/editor/EditorHome.svelte';
  import WordBankEditor from '../components/editor/WordBankEditor.svelte';
  import FrameworkEditor from '../components/editor/FrameworkEditor.svelte';
  import PromptEditor from '../components/editor/PromptEditor.svelte';

  const routes = {
    '/edit': EditorHome,
    '/edit/wordbanks': WordBankEditor,
    '/edit/frameworks': FrameworkEditor,
    '/edit/prompts': PromptEditor,
  };
</script>

<EditorLayout>
  <Router {routes} />
</EditorLayout>
